/**
 * Build the query params for the PO Headers tab-count probes from the list
 * query params.
 *
 * The probes reuse the user-applied filters (supplier, site, dates, commodity,
 * view context…) but each tab supplies its own status, and they must never
 * inherit the list's page number: on page 2 of a tab whose sibling tab has a
 * single order, `?page=2&page_size=1` 404s ("Invalid page") and used to blank
 * the whole list.
 *
 * @param listParams - The params used for the list request
 * @returns Params safe for a `page_size=1` count probe (always page 1)
 */
export function buildPOHeaderCountParams(
  listParams: Record<string, string | number | boolean>,
): Record<string, string | number | boolean> {
  const {
    status: _ignoredStatus,
    status__in: _ignoredStatusIn,
    page: _ignoredPage,
    ...countFilters
  } = listParams;
  void _ignoredStatus; void _ignoredStatusIn; void _ignoredPage;
  return { ...countFilters, page: 1, page_size: 1 };
}
